export default __webpack_public_path__ + "817c923.png";